import { useState } from 'react'
import { readConsent, writeConsent, type Consent } from '../lib/analytics'

/**
 * Cookie-samtycke för GA4.
 *
 * Startvärdet läses en gång ur localStorage i initieraren, inte i en effekt —
 * annars hade bannern blinkat förbi för alla som redan svarat.
 *
 * Inget "inställningar"-steg: enda valet som finns att göra är statistik på
 * eller av, och en dialog för en enda växel är bara ett extra klick.
 */
export function CookieBanner() {
  const [consent, setConsent] = useState<Consent | null>(() => readConsent())

  if (consent) return null

  const answer = (value: Consent) => {
    writeConsent(value)
    setConsent(value)
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookies">
      <p>
        Majortipset använder Google Analytics för att se hur sidan används. Säger du nej
        mäts besöket anonymt och utan cookies — spelet fungerar likadant.
      </p>
      <div className="cookie-banner__actions">
        <button className="primary" onClick={() => answer('granted')}>
          Acceptera
        </button>
        <button onClick={() => answer('denied')}>Bara nödvändiga</button>
      </div>
    </div>
  )
}
